<template>
    <el-table
            row-key="id"
            border
            height="100%"
            :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
            v-bind="$attrs"
            v-on="$listeners"
            >
        <slot></slot>
    </el-table>
</template>

<script>
    export default {
        registryName: 'tree-table'
    }
</script>



// WEBPACK FOOTER //
// src/components/TreeTable.vue